import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { routes as ROUTES } from 'constants/config';
import request from 'utils/request_ajax.js';
import * as actions from 'actions/pathBuilder';
import Fade from 'components/shared/animated/Fade';
import InfoTooltip from 'components/shared/InfoTooltip';

const CHECKBOX_ID = 'CertificationShareToggle';

const requestUpdateCertification = (pathId, certification) =>
  request.putJSON(ROUTES.PATH(pathId), { certification });

const CertificationShareToggle = ({ pathId, certification, updatePath }) => {
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const onChecked = () => {
    setIsLoading(true);
    setHasError(false);
    return requestUpdateCertification(pathId, {
      ...certification,
      public: !certification.public,
    })
      .then(response => {
        if (!response.success) {
          setIsLoading(false);
          setHasError(true);
          console.error(response);
          return response;
        }

        updatePath({ certification: response.certification });
        setIsLoading(false);
        return response;
      })
      .catch(e => {
        setIsLoading(false);
        setHasError(true);
        console.error(e);
      });
  };

  return (
    <>
      <Fade in={hasError}>
        <div className="ErrorContainer">
          {hasError && t('common.server_error')}
        </div>
      </Fade>
      <div className="d-f ai-fs">
        <input
          disabled={isLoading}
          onChange={onChecked}
          id={CHECKBOX_ID}
          type="checkbox"
          checked={certification.public}
          value="CertificationShareToggle"
        />
        <label htmlFor={CHECKBOX_ID} className="ml-8">
          {t('paths.path_builder.sidebar.toggle_shareable')}
          <InfoTooltip
            tooltip={t('paths.path_builder.sidebar.toggle_shareable_tooltip')}
            className="ml-4"
          />
        </label>
      </div>
    </>
  );
};

CertificationShareToggle.propTypes = {
  pathId: PropTypes.number,
  updatePath: PropTypes.func,
  certification: PropTypes.shape({
    id: PropTypes.number,
    iconName: PropTypes.string,
    backgroundColor: PropTypes.string,
    foregroundColor: PropTypes.string,
    public: PropTypes.bool,
  }),
};

const mapStateToProps = ({ pathBuilder }) => ({
  pathId: pathBuilder.id,
  certification: pathBuilder.certification || {},
});

const mapDispatchToProps = {
  updatePath: actions.updatePath,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CertificationShareToggle);
